import { EmailTemplate } from "@models/email-templates/email-template";
import { IEmailAndTextTemplatePayloadData } from "@models/email-templates/email-templates-helper";
import { ReminderSendingType } from "@models/reminders/reminder.enum";
import { TextMessageTemplate } from "@models/text-messages-templates/text-message-template";


export class AdHocReminderModel {
  documentId: string | null;
  entityId: string | null;
  sendingType: ReminderSendingType;
  phones: string[];
  emailPayloadModel: Partial<IEmailAndTextTemplatePayloadData> | null;
  emailTemplate: EmailTemplate | null;
  textPayloadModel: Partial<IEmailAndTextTemplatePayloadData> | null;
  textTemplate: TextMessageTemplate | null;

  constructor(data: Partial<AdHocReminderModel> = {}) {
    this.documentId = data.documentId ?? null;
    this.entityId = data.entityId ?? null;
    this.sendingType = data.sendingType ?? ReminderSendingType.Email;
    this.phones = data.phones ?? [];
    this.emailPayloadModel = data.emailPayloadModel ?? null;
    this.emailTemplate = data.emailTemplate ?? null;
    this.textPayloadModel = data.textPayloadModel ?? null;
    this.textTemplate = data.textTemplate ?? null;
  }
}
